import React from 'react';
import FiverMiniViz from './viz/FiverMiniViz';
import TrafficLightMiniViz from './viz/TrafficLightMiniViz';
import NumberMiniViz from './viz/NumberMiniViz';
import BinaryMiniViz from './viz/BinaryMiniViz';

interface MeasurementProps {
  measurement: {
    tracker: {
      name: string;
      type: TrackerType;
      slug: string;
    };
    value: any;
  };
}

const Measurement: React.FC<MeasurementProps> = ({ measurement }) => {
  const { value, tracker } = measurement;
  const { name, type, slug } = tracker;
  return (
    <div data-testid={`tracker-${slug}`} className="bt b--light-gray">
      <div className="flex items-center justify-between f6 pv3">
        <span className="f6" data-testid="tracker-name">
          {name}
        </span>
        {type === 'FIVER' && <FiverMiniViz value={value} />}
        {type === 'TRAFFIC_LIGHT' && <TrafficLightMiniViz value={value} />}
        {type === 'INTEGER' && <NumberMiniViz value={value} />}
        {type === 'BINARY' && <BinaryMiniViz value={value} />}
      </div>
    </div>
  );
};

export default Measurement;
